import { render, staticRenderFns } from "./ReciveAccounts.vue?vue&type=template&id=451ccc88&"
import script from "./ReciveAccounts.vue?vue&type=script&lang=js&"
export * from "./ReciveAccounts.vue?vue&type=script&lang=js&"
import style0 from "./ReciveAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports